import * as React from 'react';

import { buttonStyle, buttonVariants } from '@rtkwlf/fenrir-react';
import type { ButtonProps } from '@rtkwlf/fenrir-react';
import { clsx } from 'clsx';
import { Link } from 'react-router-dom';

import styles from './link-button.module.css';

/* -------------------------------------------------------------------------------------------------
 * LinkButton
 * -----------------------------------------------------------------------------------------------*/
type LinkButtonElementType = React.ElementRef<typeof Link>;
type LinkButtonComponentProps = Omit<
  React.ComponentPropsWithoutRef<typeof Link>,
  'to'
>;

interface LinkButtonProps {
  appearance?: ButtonProps['appearance'];
  className?: string;
  elementProps?: LinkButtonComponentProps;
  href: string;
  variant?: ButtonProps['variant'];
  disabled?: boolean;
}

const LinkButton = React.forwardRef<
  LinkButtonElementType,
  React.PropsWithChildren<LinkButtonProps>
>(
  (
    {
      appearance = 'default',
      children,
      className,
      elementProps,
      href,
      variant = 'primary',
      disabled = false,
      ...props
    },
    forwardedRef,
  ) => {
    return (
      <Link
        {...props}
        {...elementProps}
        to={href}
        ref={forwardedRef}
        className={clsx(
          className,
          buttonStyle,
          buttonVariants[variant][appearance],
          styles['link-button'],
        )}
        aria-disabled={disabled}
      >
        {children}
      </Link>
    );
  },
);

LinkButton.displayName = 'LinkButton';

export { LinkButton };

export type { LinkButtonProps };
